var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"text-center analyze-button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.disabled)?_c('b-spinner',{staticClass:"spinner",attrs:{"small":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }